<template>
    <!-- Scelta del pacchetto BIA (#213). Non compare se il prodotto non ha variazioni pacchetto. -->
    <div v-if="packs.length" class="bia-pack-picker mt-2" role="radiogroup" aria-label="Pacchetto BIA">
        <label class="form-label">Scegli il pacchetto</label>
        <div class="form-check d-flex justify-content-between">
            <span>
                <input class="form-check-input" type="radio" id="bia-pack-single" name="bia-pack"
                    :checked="!modelValue" @change="$emit('update:modelValue', null)" />
                <label class="form-check-label" for="bia-pack-single">BIA singola</label>
            </span>
            <span class="highlight">{{ formatPrice(singlePrice) }}€</span>
        </div>
        <div v-for="(p, i) in packs" :key="p.name" class="form-check d-flex justify-content-between">
            <span>
                <input class="form-check-input" type="radio" :id="'bia-pack-' + i" name="bia-pack"
                    :checked="modelValue === p.name" @change="$emit('update:modelValue', p.name)" />
                <label class="form-check-label" :for="'bia-pack-' + i">{{ p.label }}</label>
            </span>
            <span class="highlight">{{ formatPrice(p.price) }}€</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BiaPackPicker',
    props: {
        packs: { type: Array, default: () => [] },
        modelValue: { type: String, default: null },
        singlePrice: { type: Number, default: 0 },
    },
    emits: ['update:modelValue'],
    methods: {
        formatPrice(v) { return Number(v || 0).toFixed(2); },
    },
};
</script>

<style scoped>
.bia-pack-picker { overflow-wrap: anywhere; }
</style>
